// extracted by mini-css-extract-plugin
export default {"popover":"Form_popover__K++Zv","checkbox-row":"Form_checkbox-row__dT1iZ","form":"Form_form__AwKKQ","save":"Form_save__zZzh5"};